import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import { useAvatarsByAdmin } from '../../../hooks/admin/avatars.admin';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import EmptyData from '../../../components/ui/EmptyData';
import AvatarsTable from '../../../components/admin/avatars/AdminAvatarsListTable';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function AdminViewAllAvatarsPage() {
    const {t} = useTranslation();
    const {data:avatars , isError, isLoading} = useAvatarsByAdmin();
  return (
    <Layout title={t("admin_sidebar.avatars")} headline=''>
         <div className='flex justify-end'>
            <PermissionGate permissions={[PermissionsKey.CreateAvatar]}>
              <PrimaryButtonWithIconAdd
                buttonLabel="add_new_avatar"
                buttonLinkPath={`/admin/add-avatar`}
              />
            </PermissionGate>
         </div>
         <LoadingErrorState
         isError={isError}
         isLoading={isLoading}
         />
          {
        avatars && (
          avatars.length === 0 ?<EmptyData/> : <AvatarsTable avatars={avatars}/>
        )
        }
    </Layout>
  )
}

export default AdminViewAllAvatarsPage